import React from "react";

export interface MedicationTitleProps {
    heading: string;
    banner?: string;
    subHeading?: string;
    imgUrl?: string;
    imgAltText?: string;
}

const MedicationCardTitle = (props: MedicationTitleProps) => {
    const generateMedicationBanner = () => {
        return (<pui-text input={ props.banner } class="medication-banner" spacingBottom="small" fontWeight="bold"></pui-text>);
    }

    const generateMedicationHeading = () => {
        return (<pui-heading input={ props.heading } textSize="extra-large" spacingBottom="small" headinglevel="1"></pui-heading>);
    }

    const generateMedicationSubHeading = () => {
        return (<pui-text input={ props.subHeading } textSize="medium"
                          textAlign="left"
                          textColor="grey"></pui-text>);
    }

    const generateMedicationImage = () => {
        return (
            <pui-section-column flexGrid='20'>
                {props.imgUrl && (
                    <img src={props.imgUrl} alt={props.imgAltText} width="60px" height="60px"/>
                )}
            </pui-section-column>
        )
    }

    return (
        <pui-card fullWidth class="title-card" flowdirection="horizontal" spacingBottom="medium">
            <pui-section flowDirection='horizontal' fullWidth>
                <pui-section-column flexGrid='80'>
                    {props.banner && generateMedicationBanner()}
                    {generateMedicationHeading()}
                    {props.subHeading && generateMedicationSubHeading()}
                </pui-section-column>
                {props.imgUrl && generateMedicationImage()}
            </pui-section>
        </pui-card>
    )
}
export default MedicationCardTitle;
